module.exports = __webpack_public_path__ + "img/lazer.0317df71.svg";